import CancelIcon from '@mui/icons-material/Cancel';
import { BaseModalProps } from './baseModal.interface';
import * as S from './baseModal.styles';

const BaseModal = ({ children, className, open, closeModal }: BaseModalProps) => {
  return (
    <S.ModalContainer $active={open}>
      <S.ModalContainerBg $active={open} onClick={closeModal}></S.ModalContainerBg>
      <S.ModalContainerContent $active={open} className={className}>
        <S.ModalContainerContentHead>
          <CancelIcon onClick={closeModal} />
        </S.ModalContainerContentHead>
        <S.ModalContainerContentHead>{children}</S.ModalContainerContentHead>
      </S.ModalContainerContent>
    </S.ModalContainer>
  );
};

BaseModal.defaultProps = {
  closeAble: true,
};

export default BaseModal;
